import * as Service from 'types/service';
import { PrintChitSource } from 'constants/PrinterConstants';
import { canMarkPartyAsLeft } from 'utils/partyUtils';
import { noop } from 'es-toolkit';

interface HandlePartyStatusSelectionParams {
  party: Service.Party;
  option: Service.StateDescription;
  printOnSeat: boolean;
  onPrintChit?: (party: Service.Party, source: PrintChitSource) => void;
  isPrintPartiallySeatedEnabled: boolean;
  confirm: (message: string) => Promise<unknown>;
  onConfirmOrImmediateSelect: () => void;
}

const FINISH_PARTY_CONFIRMATION =
  'You haven’t collected payment from this party yet. Are you sure you’d like to mark them as finished?';

export const handlePartyStatusSelection = ({
  party,
  option,
  printOnSeat,
  onPrintChit,
  isPrintPartiallySeatedEnabled,
  confirm,
  onConfirmOrImmediateSelect,
}: HandlePartyStatusSelectionParams): void => {
  if (
    printOnSeat &&
    onPrintChit &&
    ((option.primaryState === 'PARTIALLY_SEATED' && isPrintPartiallySeatedEnabled) ||
      option.primaryState === 'SEATED') &&
    option.secondaryValue === null
  ) {
    onPrintChit(party, PrintChitSource.AUTOMATIC);
  }

  if (!canMarkPartyAsLeft(party) && option.primaryState === 'LEFT') {
    confirm(FINISH_PARTY_CONFIRMATION).then(onConfirmOrImmediateSelect).catch(noop);
    return;
  }

  onConfirmOrImmediateSelect();
};
